import CustomForm from '../../lib/FormValidator/Form/CustomForm';
import { PlanillaPartido } from '../../system/PlanillaPartido/PlanillaPartido';
import { PlanillaDigitalAssertions } from '../../system/PlanillaPartido/PlanillaDigitalAssertions';
import { PlanillaPartidoJugador } from '../../system/PlanillaPartidoJugador/PlanillaPartidoJugador';
import { EventoXPlanilla } from '../../system/EventoXPlanilla/EventoXPlanilla';
import { TimeoutXPlanilla } from '../../system/TimeoutXPlanilla/TimeoutXPlanilla';
import {
  DOS_MINUTOS,
  GOL,
  PENAL,
  TARJETA_AMARILLA,
  TARJETA_AZUL,
  TARJETA_ROJA,
  TipoEventoPlanilla,
} from '../../system/TipoEventoPlanilla/TipoEventoPlanilla';
import { PlanillaPartidoOficial } from '../../system/PlanillaPartidoOficial/PlanillaPartidoOficial';
import PlanillaDigitalFormEventMngr from './PlanillaDigitalFormEventMngr';
import { IPeriodos } from './PlanillaDigitalView';
import { ErrorEvent } from './PlanillaDigitalFormEventMngr';
import { PlanillaPartidoOficialAuxiliar } from '../../system/PlanillaPartidoOficialAuxiliar/PlanillaPartidoOficialAuxiliar';
import { PlanillaPartidoEnVivo } from '../../system/PlanillaPartidoEnVivo/PlanillaPartidoEnVivo';
import { PlanillaPartidoOficialMesaNoRegsitrado } from '../../system/PlanillaPartidoOficialMesaNoRegsitrado/PlanillaPartidoOficialMesaNoRegsitrado';
const DURACION_SANCION_EN_MINUTOS = 2;
const CANT_MAX_TIMEOUTS_POR_TIEMPO = 2;
const CANT_MAX_TIMEOUTS_EN_TIEMPO_REGLAMENTARIO = 3;
const CANT_MAX_TIMEOUTS_EN_TIEMPOS_EXTRA = 1;
export const DURACION_SANCION_EN_SEGUNDOS = DURACION_SANCION_EN_MINUTOS * 60;
export const ROL_JUGADOR = 'Jugador';
export const ROL_OFICIAL = 'Oficial';
export const ROL_OFICIAL_AUXILIAR = 'Oficial Auxiliar';

interface ExclusionData {
  id: any;
  rol: any;
  dorsal: any;
  minuto: string;
  restante: string;
  restanteSeconds: number;
}

class PlanillaDigitalForm extends CustomForm {
  protected constructor(
    planilla_partido: PlanillaPartido,
    planilla_eventos: EventoXPlanilla[],
    timeout_x_planilla: TimeoutXPlanilla[],
    informe: boolean,
    observaciones: string
  ) {
    const pla = PlanillaDigitalAssertions.build();
    super('PlanillaDigital', pla);
    this.addInputAsserted('planilla_partido', planilla_partido);
    this.addInput('planilla_eventos', planilla_eventos);
    this.addInput('timeout_x_planilla', timeout_x_planilla);
    this.addInput('informe', informe);
    this.addInput('observaciones', observaciones);
  }

  public static build(
    planilla_partido: PlanillaPartido,
    planilla_eventos: EventoXPlanilla[],
    timeout_x_planilla: TimeoutXPlanilla[],
    informe: boolean,
    observaciones: string
  ) {
    return new this(planilla_partido, planilla_eventos, timeout_x_planilla, informe, observaciones);
  }

  getPlanillaPartidoInput() {
    return this.getInputByName('planilla_partido');
  }

  getPlanillaEventoInput() {
    return this.getInputByName('planilla_eventos');
  }

  getTimeoutXPlanillaInput() {
    return this.getInputByName('timeout_x_planilla');
  }

  getInformeInput() {
    return this.getInputByName('informe');
  }

  getObservacionesInput() {
    return this.getInputByName('observaciones');
  }

  getEquipoLocal() {
    const planillaPartido = this.getPlanillaPartidoInput().getValue() as PlanillaPartido;
    const equipoLocal = planillaPartido.getPartido().getLocal();
    return equipoLocal!;
  }

  getEquipoVisitante() {
    const planillaPartido = this.getPlanillaPartidoInput().getValue() as PlanillaPartido;
    const equipoVisitante = planillaPartido.getPartido().getVisitante();
    return equipoVisitante!;
  }

  getJugadoresLocales() {
    const planillaPartido = this.getPlanillaPartidoInput().getValue() as PlanillaPartido;
    const equipoLocalId = planillaPartido.getPartido().getEqidLocal();
    const jugadoresLocales = planillaPartido
      .getPlanillaPartidoJugadorList()
      .filter((ppj) => +ppj.getEqid() === +equipoLocalId!)
      .map((ppj) => ppj.getJugador());
    return jugadoresLocales;
  }

  getJugadoresVisitantes() {
    const planillaPartido = this.getPlanillaPartidoInput().getValue() as PlanillaPartido;
    const equipoVisitanteId = planillaPartido.getPartido().getEqidVisitante();
    const jugadoresVisitantes = planillaPartido
      .getPlanillaPartidoJugadorList()
      .filter((ppj) => +ppj.getEqid() === +equipoVisitanteId!)
      .map((ppj) => ppj.getJugador());
    return jugadoresVisitantes;
  }

  getPlanillaPartidoJugadorLocales() {
    const planillaPartido = this.getPlanillaPartidoInput().getValue() as PlanillaPartido;
    const equipoLocalId = planillaPartido.getPartido().getEqidLocal();
    const jugadoresLocales = planillaPartido
      .getPlanillaPartidoJugadorList()
      .filter((ppj) => +ppj.getEqid() === +equipoLocalId!);
    return jugadoresLocales;
  }

  getPlanillaPartidoJugadorVisitantes() {
    const planillaPartido = this.getPlanillaPartidoInput().getValue() as PlanillaPartido;
    const equipoVisitanteId = planillaPartido.getPartido().getEqidVisitante();
    const jugadoresVisitantes = planillaPartido
      .getPlanillaPartidoJugadorList()
      .filter((ppj) => +ppj.getEqid() === +equipoVisitanteId!);
    return jugadoresVisitantes;
  }

  getOficialesLocales() {
    const planillaPartido = this.getPlanillaPartidoInput().getValue() as PlanillaPartido;
    const equipoLocalId = planillaPartido.getPartido().getEqidLocal();
    const oficialesLocales = planillaPartido
      .getPlanillaPartidoOficialList()
      .filter((ppo) => +ppo.getEqid() === +equipoLocalId!)
      .map((ppo) => ppo.getEntrenador());

    return oficialesLocales;
  }

  getOficialesVisitantes() {
    const planillaPartido = this.getPlanillaPartidoInput().getValue() as PlanillaPartido;
    const equipoVisitanteId = planillaPartido.getPartido().getEqidVisitante();
    const oficialesVisitantes = planillaPartido
      .getPlanillaPartidoOficialList()
      .filter((ppo) => +ppo.getEqid() === +equipoVisitanteId!)
      .map((ppo) => ppo.getEntrenador());
    return oficialesVisitantes;
  }

  getTimeoutsLocal() {
    const equipoLocalId = this.getEquipoLocal().getId();
    return this.getTimeoutsByEquipoItems(+equipoLocalId!);
  }

  getTimeoutsVisitante() {
    const equipoVisitanteId = this.getEquipoVisitante().getId();
    return this.getTimeoutsByEquipoItems(+equipoVisitanteId!);
  }

  getTimeoutsByEquipoItems(eqId: number) {
    const timeouts = this.getTimeoutXPlanillaInput().getValue() as TimeoutXPlanilla[];
    const timeoutsDelEquipo = timeouts.filter((t) => +t.getEqid()! === eqId);
    return [
      {
        primer_to: timeoutsDelEquipo[0] ? timeoutsDelEquipo[0].getMomento() : '-',
        segundo_to: timeoutsDelEquipo[1] ? timeoutsDelEquipo[1].getMomento() : '-',
        tercer_to: timeoutsDelEquipo[2] ? timeoutsDelEquipo[2].getMomento() : '-',
        cuarto_to: timeoutsDelEquipo[3] ? timeoutsDelEquipo[3].getMomento() : '-',
      },
    ];
  }

  mapPlanillaForPDF(periodos: IPeriodos[], tiempoActual: string) {
    const planillaPartido = this.getPlanillaPartidoInput().getValue() as PlanillaPartido;

    const golesLocales = this.getGolesLocalesForList(periodos);
    const golesVisitante = this.getGolesVisitanteForList(periodos);

    return {
      torneo: planillaPartido.getPartido().getTorneo()?.getNombre(),
      hora: planillaPartido.getPartido().getHorario(),
      categoria: planillaPartido.getPartido().getTorneo()?.getCategoria(),
      fecha: planillaPartido.getPartido().getFecha(),
      cancha: planillaPartido.getPartido().getCampoJuego()?.getNombre(),
      numero_de_fecha: planillaPartido.getPartido().getNumeroFecha(),
      nombreEquipoLocal: planillaPartido.getPartido().getLocal()?.getClub()?.getNombre(),
      nombreEquipoVisitante: planillaPartido.getPartido().getVisitante()?.getClub()?.getNombre(),
      golesTotalesLocal: this.getCantidadGolesLocal(),
      golesTotalesVisitante: this.getCantidadGolesVisitante(),
      golesLocales: golesLocales,
      golesVisitante: golesVisitante,
      jugadoresLocales: this.getJugadoresLocalesForList(tiempoActual),
      jugadoresVisitantes: this.getJugadoresVisitantesForList(tiempoActual),
      arbitro1:
        planillaPartido.getArbitro1().getApellido() + ', ' + planillaPartido.getArbitro1().getNombre(),
      arbitro2: planillaPartido.getArbitro2()
        ? planillaPartido.getArbitro2()?.getApellido() + ', ' + planillaPartido.getArbitro2()?.getNombre()
        : '',
      oficialesMesaLocales: this.getOficialesMesaLocalesForList(),
      oficialesMesaVisitantes: this.getOficialesMesaVisitantesForList(),
      oficialesLocales: this.getOficialesLocalesForList(),
      oficialesVisitantes: this.getOficialesVisitantesForList(),
      timeoutsLocal: this.getTimeoutsLocal(),
      timeoutsVisitante: this.getTimeoutsVisitante(),
      observaciones: planillaPartido.getObservacion(),
      provincia: planillaPartido.getPartido().getCampoJuego()?.getLocalidad(),
    };
  }

  mapJugadorForList(ppj: PlanillaPartidoJugador, tiempoActual: string) {
    return {
      ppj_id: ppj.getId(),
      dorsal: ppj.getDorsal(),
      jug_nombre: ppj.getJugador().fullname(),
      exclusion: this.getTiempoRestanteExclusionXJugador(ppj.getId()?.toString()!, tiempoActual)
        ? this.getTiempoRestanteExclusionXJugador(ppj.getId()?.toString()!, tiempoActual)
        : '',
      goles:
        this.getCantidadEventosXJugador(PENAL, +ppj.getId()!) +
          this.getCantidadEventosXJugador(GOL, +ppj.getId()!) >
        0
          ? this.getCantidadEventosXJugador(PENAL, +ppj.getId()!) +
            this.getCantidadEventosXJugador(GOL, +ppj.getId()!)
          : '-',
      amarillas:
        this.getCantidadEventosXJugador(TARJETA_AMARILLA, +ppj.getId()!) > 0
          ? this.getCantidadEventosXJugador(TARJETA_AMARILLA, +ppj.getId()!)
          : '-',
      suspensiones:
        this.getCantidadEventosXJugador(DOS_MINUTOS, +ppj.getId()!) > 0
          ? this.getCantidadEventosXJugador(DOS_MINUTOS, +ppj.getId()!)
          : '-',
      rojas:
        this.getCantidadEventosXJugador(TARJETA_ROJA, +ppj.getId()!) > 0
          ? this.getCantidadEventosXJugador(TARJETA_ROJA, +ppj.getId()!)
          : '-',
      azules:
        this.getCantidadEventosXJugador(TARJETA_AZUL, +ppj.getId()!) > 0
          ? this.getCantidadEventosXJugador(TARJETA_AZUL, +ppj.getId()!)
          : '-',
    };
  }

  mapEventoForList(exp: EventoXPlanilla) {
    let id: any = '';
    let nombre: any = '';
    let equipoId: any = '';
    if (exp.getPlanillaPartidoJugador()) {
      id = exp.getPlanillaPartidoJugador()?.getDorsal();
      nombre = exp.getPlanillaPartidoJugador()?.getJugador().fullname();
      equipoId = exp.getPlanillaPartidoJugador()?.getEqid();
    } else if (exp.getPlanillaPartidoOficial()) {
      id = exp.getPlanillaPartidoOficial()?.getEntrenador().getTipo();
      nombre =
        exp.getPlanillaPartidoOficial()?.getEntrenador().getApellido() +
        ', ' +
        exp.getPlanillaPartidoOficial()?.getEntrenador().getNombre();
      equipoId = exp.getPlanillaPartidoOficial()?.getEqid();
    } else if (exp.getPlanillaPartidoOficialAuxiliar()) {
      id = exp.getPlanillaPartidoOficialAuxiliar()?.getOrden();
      nombre =
        exp.getPlanillaPartidoOficialAuxiliar()?.getApellido() +
        ', ' +
        exp.getPlanillaPartidoOficialAuxiliar()?.getNombre();
      equipoId = exp.getPlanillaPartidoOficialAuxiliar()?.getEqid();
    }

    const equipo = this.getEquipoById(+equipoId!);
    return {
      id: id,
      id_artificial_evento: exp.getIdArtifical(),
      evento: exp.getTipoEventoPlanilla()?.getNombre(),
      nombre: nombre,
      minuto: exp.getMinuto(),
      exp_id: exp.getId(),
      club: equipo?.getClub()?.getEscudo(),
    };
  }

  mapGolesForList(exp: EventoXPlanilla[], penales: EventoXPlanilla[], periodos: IPeriodos[]) {
    const planillaPartido = this.getPlanillaPartidoInput().getValue() as PlanillaPartido;
    const categoria = planillaPartido.getPartido().getTorneo()?.getCategoria();
    const duracionPeriodoSeg = categoria?.getDuracionPeriodo()! * 60;
    const duracionPeriodoExtraSeg = categoria?.getDuracionPeriodoExtra()! * 60;

    let golesPrimerTiempo: string | number = exp.filter(
      (ev) => +ev.getMinutoEnSegundos() < +duracionPeriodoSeg!
    ).length;

    let golesSegundoTiempo: string | number = exp.filter(
      (ev) =>
        +ev.getMinutoEnSegundos() >= +duracionPeriodoSeg! &&
        +ev.getMinutoEnSegundos() < +duracionPeriodoSeg! * 2
    ).length;

    let golesPrimerTiempoExtra: string | number = exp.filter(
      (ev) =>
        +ev.getMinutoEnSegundos() >= +duracionPeriodoSeg! * 2 &&
        +ev.getMinutoEnSegundos() < duracionPeriodoExtraSeg! + +duracionPeriodoSeg! * 2
    ).length;

    let golesSegundoTiempoExtra: string | number = exp.filter(
      (ev) =>
        +ev.getMinutoEnSegundos() >= +duracionPeriodoSeg! * 2 &&
        +ev.getMinutoEnSegundos() >= duracionPeriodoExtraSeg! + +duracionPeriodoSeg! * 2 &&
        +ev.getMinutoEnSegundos() < duracionPeriodoExtraSeg! * 2 + +duracionPeriodoSeg! * 2
    ).length;

    if (
      !periodos.find((periodo) => periodo.desc === 'PT')?.isPlaying &&
      !periodos.find((periodo) => periodo.desc === 'PT')?.isFinished
    ) {
      golesPrimerTiempo = '-';
    }

    if (
      !periodos.find((periodo) => periodo.desc === 'ST')?.isPlaying &&
      !periodos.find((periodo) => periodo.desc === 'ST')?.isFinished
    ) {
      golesSegundoTiempo = '-';
    }

    if (
      !periodos.find((periodo) => periodo.desc === 'PTE')?.isPlaying &&
      !periodos.find((periodo) => periodo.desc === 'PTE')?.isFinished
    ) {
      golesPrimerTiempoExtra = '-';
    }

    if (
      !periodos.find((periodo) => periodo.desc === 'STE')?.isPlaying &&
      !periodos.find((periodo) => periodo.desc === 'STE')?.isFinished
    ) {
      golesSegundoTiempoExtra = '-';
    }

    return [
      {
        pt: golesPrimerTiempo,
        st: golesSegundoTiempo,
        pte: golesPrimerTiempoExtra,
        ste: golesSegundoTiempoExtra,
        p: penales.length,
      },
    ];
  }

  mapExclusionInfo(exp: EventoXPlanilla) {
    let id: any = null;
    let rol: any = null;
    let dorsal: any = null;
    let nombre: any = null;
    if (exp.getPlanillaPartidoJugador()) {
      id = exp.getPlanillaPartidoJugador()?.getId();
      rol = ROL_JUGADOR;
      dorsal = exp.getPlanillaPartidoJugador()?.getDorsal();
      nombre = exp.getPlanillaPartidoJugador()?.getJugador().fullname();
    } else if (exp.getPlanillaPartidoOficial()) {
      id = exp.getPlanillaPartidoOficial()?.getId();
      rol = ROL_OFICIAL;
      dorsal = 'A';
      nombre =
        exp.getPlanillaPartidoOficial()?.getEntrenador().getApellido() +
        ', ' +
        exp.getPlanillaPartidoOficial()?.getEntrenador().getNombre();
    } else if (exp.getPlanillaPartidoOficialAuxiliar()) {
      id = exp.getPlanillaPartidoOficialAuxiliar()?.getId();
      rol = ROL_OFICIAL_AUXILIAR;
      dorsal = exp.getPlanillaPartidoOficialAuxiliar()?.getOrden();
      nombre =
        exp.getPlanillaPartidoOficialAuxiliar()?.getApellido() +
        ', ' +
        exp.getPlanillaPartidoOficialAuxiliar()?.getNombre();
    }
    return {
      id: id,
      rol: rol,
      dorsal: dorsal,
      nombre: nombre,
    };
  }

  mapExclusionForList(exp: EventoXPlanilla, _tiempoActual: string) {
    const planillaPartido = this.getPlanillaPartidoInput().getValue() as PlanillaPartido;
    const exclusionInfo = this.mapExclusionInfo(exp);
    const restanteSeconds = exp.getTiempoRestante(_tiempoActual);
    const restante = this.getTiempoRestante(restanteSeconds);

    return {
      id: exclusionInfo.id,
      rol: exclusionInfo.rol,
      dorsal: exclusionInfo.dorsal,
      minuto: exp.getMinuto(),
      restante: restante,
      restanteSeconds: restanteSeconds,
      nombre: exclusionInfo.nombre,
    };
  }

  getTiempoRestante(restanteSeconds: number) {
    let minutosFaltantes = Math.floor(restanteSeconds / 60);
    let segundosFaltantes = restanteSeconds % 60;

    var tiempoFaltanteFormateado =
      minutosFaltantes.toString().padStart(2, '0') + ':' + segundosFaltantes.toString().padStart(2, '0');
    return tiempoFaltanteFormateado;
  }

  getJugadoresLocalesForList(tiempoActual: string) {
    const planillaPartido = this.getPlanillaPartidoInput().getValue() as PlanillaPartido;
    const equipoLocalId = planillaPartido.getPartido().getEqidLocal();
    const jugadoresLocales = planillaPartido
      .getPlanillaPartidoJugadorList()
      .filter((ppj) => +ppj.getEqid() === +equipoLocalId!)
      .sort((ppj1, ppj2) => (+ppj1.getDorsal() < +ppj2.getDorsal() ? -1 : 1))
      .map((ppj) => this.mapJugadorForList(ppj, tiempoActual));

    return jugadoresLocales;
  }

  getJugadoresVisitantesForList(tiempoActual: string) {
    const planillaPartido = this.getPlanillaPartidoInput().getValue() as PlanillaPartido;
    const equipoVisitanteId = planillaPartido.getPartido().getEqidVisitante();
    const jugadoresVisitantes = planillaPartido
      .getPlanillaPartidoJugadorList()
      .filter((ppj) => +ppj.getEqid() === +equipoVisitanteId!)
      .sort((ppj1, ppj2) => (+ppj1.getDorsal() < +ppj2.getDorsal() ? -1 : 1))
      .map((ppj) => this.mapJugadorForList(ppj, tiempoActual));

    return jugadoresVisitantes;
  }

  getOficialesLocalesForList() {
    const planillaPartido = this.getPlanillaPartidoInput().getValue() as PlanillaPartido;
    const equipoLocalId = planillaPartido.getPartido().getEqidLocal();
    const oficialesLocales = planillaPartido
      .getPlanillaPartidoOficialList()
      .filter((ppo) => +ppo.getEqid() === +equipoLocalId!)
      .map((ppo) => this.mapOficialForList(ppo));

    const oficialesAuxiliaresLocales = planillaPartido
      .getPlanillaPartidoOficialAuxiliarList()
      .filter((ppoa) => +ppoa.getEqid() === +equipoLocalId!)
      .map((ppoa) => this.mapOficialAuxiliarForList(ppoa));

    return oficialesLocales.concat(oficialesAuxiliaresLocales);
  }

  getOficialesVisitantesForList() {
    const planillaPartido = this.getPlanillaPartidoInput().getValue() as PlanillaPartido;
    const equipoVisitanteId = planillaPartido.getPartido().getEqidVisitante();
    const oficialesVisitantes = planillaPartido
      .getPlanillaPartidoOficialList()
      .filter((ppo) => +ppo.getEqid() === +equipoVisitanteId!)
      .map((ppo) => this.mapOficialForList(ppo));

    const oficialesAuxiliaresVisitantes = planillaPartido
      .getPlanillaPartidoOficialAuxiliarList()
      .filter((ppoa) => +ppoa.getEqid() === +equipoVisitanteId!)
      .map((ppoa) => this.mapOficialAuxiliarForList(ppoa));

    return oficialesVisitantes.concat(oficialesAuxiliaresVisitantes);
  }

  mapOficialForList(ppo: PlanillaPartidoOficial) {
    return {
      oficialId: ppo.getId(),
      tipo: 'A',
      nombre: ppo.getEntrenador().getApellido() + ', ' + ppo.getEntrenador().getNombre(),
      amarillas:
        this.getCantidadEventosXOficial(TARJETA_AMARILLA, +ppo.getId()!) > 0
          ? this.getCantidadEventosXOficial(TARJETA_AMARILLA, +ppo.getId()!)
          : '-',
      suspensiones:
        this.getCantidadEventosXOficial(DOS_MINUTOS, +ppo.getId()!) > 0
          ? this.getCantidadEventosXOficial(DOS_MINUTOS, +ppo.getId()!)
          : '-',
      rojas:
        this.getCantidadEventosXOficial(TARJETA_ROJA, +ppo.getId()!) > 0
          ? this.getCantidadEventosXOficial(TARJETA_ROJA, +ppo.getId()!)
          : '-',
      azules:
        this.getCantidadEventosXOficial(TARJETA_AZUL, +ppo.getId()!) > 0
          ? this.getCantidadEventosXOficial(TARJETA_AZUL, +ppo.getId()!)
          : '-',
    };
  }

  mapOficialAuxiliarForList(ppoa: PlanillaPartidoOficialAuxiliar) {
    return {
      oficialId: ppoa.getId(),
      tipo: ppoa.getOrden(),
      nombre: ppoa.getApellido() + ', ' + ppoa.getNombre(),
      amarillas:
        this.getCantidadEventosXOficialAuxiliar(TARJETA_AMARILLA, +ppoa.getId()!) > 0
          ? this.getCantidadEventosXOficialAuxiliar(TARJETA_AMARILLA, +ppoa.getId()!)
          : '-',
      suspensiones:
        this.getCantidadEventosXOficialAuxiliar(DOS_MINUTOS, +ppoa.getId()!) > 0
          ? this.getCantidadEventosXOficialAuxiliar(DOS_MINUTOS, +ppoa.getId()!)
          : '-',
      rojas:
        this.getCantidadEventosXOficialAuxiliar(TARJETA_ROJA, +ppoa.getId()!) > 0
          ? this.getCantidadEventosXOficialAuxiliar(TARJETA_ROJA, +ppoa.getId()!)
          : '-',
      azules:
        this.getCantidadEventosXOficialAuxiliar(TARJETA_AZUL, +ppoa.getId()!) > 0
          ? this.getCantidadEventosXOficialAuxiliar(TARJETA_AZUL, +ppoa.getId()!)
          : '-',
    };
  }

  getOficialesMesaLocalesForList() {
    const planillaPartido = this.getPlanillaPartidoInput().getValue() as PlanillaPartido;
    const equipoLocalId = planillaPartido.getPartido().getEqidLocal();
    const oficialesMesaLocales = planillaPartido
      .getPlanillaPartidoOficialMesaNoRegistradoList()
      .filter((ppo) => +ppo.getEqid() === +equipoLocalId!)
      .map((ppo) => this.mapOficialMesaForList(ppo));

    return oficialesMesaLocales;
  }

  getOficialesMesaVisitantesForList() {
    const planillaPartido = this.getPlanillaPartidoInput().getValue() as PlanillaPartido;
    const equipoVisitanteId = planillaPartido.getPartido().getEqidVisitante();
    const oficialesMesaVisitantes = planillaPartido
      .getPlanillaPartidoOficialMesaNoRegistradoList()
      .filter((ppo) => +ppo.getEqid() === +equipoVisitanteId!)
      .map((ppo) => this.mapOficialMesaForList(ppo));

    return oficialesMesaVisitantes;
  }

  mapOficialMesaForList(ppom: PlanillaPartidoOficialMesaNoRegsitrado) {
    return {
      oficialId: ppom.getId(),
      nombre: ppom.getApellido() + ', ' + ppom.getNombre(),
      dni: ppom.getDni(),
    };
  }

  getTiempoRestanteExclusionXJugador(ppjId: string, tiempoActual: string) {
    const planillaEventos = this.getPlanillaEventoInput().getValue() as EventoXPlanilla[];
    const exclusiones = planillaEventos
      .filter(
        (exp) =>
          exp.getActivo() &&
          exp.getPpjid() &&
          exp.getTipoEventoPlanilla() &&
          +exp.getPpjid()! === +ppjId &&
          (exp.getTipoEventoPlanilla()?.getNombre() === DOS_MINUTOS ||
            exp.getTipoEventoPlanilla()?.getNombre() === TARJETA_ROJA)
      )
      .reduce<number>((tiempoRestanteSeconds, exp) => {
        const exclusionInfo = this.mapExclusionForList(exp, tiempoActual);
        tiempoRestanteSeconds += exclusionInfo.restanteSeconds;
        return tiempoRestanteSeconds;
      }, 0);

    if (exclusiones > 0) {
      return this.getTiempoRestante(exclusiones);
    } else {
      return undefined;
    }
  }

  getCantidadEventosXJugador(tipo: string, ppjId: number) {
    const planillaEventos = this.getPlanillaEventoInput().getValue() as EventoXPlanilla[];
    const eventos = planillaEventos.filter(
      (exp) =>
        exp.getActivo() &&
        exp.getPpjid() &&
        exp.getTipoEventoPlanilla() &&
        +exp.getPpjid()! === +ppjId &&
        exp.getTipoEventoPlanilla()!.getNombre() === tipo
    );
    return eventos.length;
  }

  getCantidadTimeoutXEquipo(eqId: number, tiempo: number) {
    const timeoutsPlanilla = this.getTimeoutXPlanillaInput().getValue() as TimeoutXPlanilla[];
    const timeouts = timeoutsPlanilla.filter((t) => +t.getEqid()! === eqId && tiempo === t.getTiempo());
    return timeouts.length;
  }

  getCantidadEventosXOficial(tipo: string, ppoId: number) {
    const planillaEventos = this.getPlanillaEventoInput().getValue() as EventoXPlanilla[];
    const eventos = planillaEventos.filter(
      (exp) =>
        exp.getActivo() &&
        exp.getPpoid() &&
        exp.getTipoEventoPlanilla() &&
        +exp.getPpoid()! === +ppoId &&
        exp.getTipoEventoPlanilla()!.getNombre() === tipo
    );
    return eventos.length;
  }

  getCantidadEventosXOficialAuxiliar(tipo: string, ppoaId: number) {
    const planillaEventos = this.getPlanillaEventoInput().getValue() as EventoXPlanilla[];
    const eventos = planillaEventos.filter(
      (exp) =>
        exp.getActivo() &&
        exp.getPpoaid() &&
        exp.getTipoEventoPlanilla() &&
        +exp.getPpoaid()! === +ppoaId &&
        exp.getTipoEventoPlanilla()!.getNombre() === tipo
    );
    return eventos.length;
  }

  getCantidadGoles(equipodId: string | null) {
    const planillaEventos = this.getPlanillaEventoInput().getValue() as EventoXPlanilla[];
    const goles = planillaEventos.filter((exp) => {
      return (
        exp.getActivo() &&
        +exp.getPlanillaPartidoJugador()?.getEqid()! === +equipodId! &&
        (exp.getTipoEventoPlanilla()?.isGol() || exp.getTipoEventoPlanilla()?.isPenal())
      );
    }).length;
    return goles;
  }

  getGolesLocalesForList(periodos: IPeriodos[]) {
    const equipoLocalId = this.getEquipoLocal().getId();
    const planillaEventos = this.getPlanillaEventoInput().getValue() as EventoXPlanilla[];
    const goles = planillaEventos.filter((exp) => {
      return (
        exp.getActivo() &&
        +exp.getPlanillaPartidoJugador()?.getEqid()! === +equipoLocalId! &&
        exp.getTipoEventoPlanilla()?.isGol()
      );
    });

    const penales = planillaEventos.filter((exp) => {
      return (
        exp.getActivo() &&
        +exp.getPlanillaPartidoJugador()?.getEqid()! === +equipoLocalId! &&
        exp.getTipoEventoPlanilla()?.isPenal()
      );
    });

    return this.mapGolesForList(goles, penales, periodos);
  }

  getGolesVisitanteForList(periodos: IPeriodos[]) {
    const equipoVisitanteId = this.getEquipoVisitante().getId();
    const planillaEventos = this.getPlanillaEventoInput().getValue() as EventoXPlanilla[];
    const goles = planillaEventos.filter((exp) => {
      return (
        exp.getActivo() &&
        +exp.getPlanillaPartidoJugador()?.getEqid()! === +equipoVisitanteId! &&
        exp.getTipoEventoPlanilla()?.isGol()
      );
    });
    const penales = planillaEventos.filter((exp) => {
      return (
        exp.getActivo() &&
        +exp.getPlanillaPartidoJugador()?.getEqid()! === +equipoVisitanteId! &&
        exp.getTipoEventoPlanilla()?.isPenal()
      );
    });

    return this.mapGolesForList(goles, penales, periodos);
  }

  esDelEquipo(exp: EventoXPlanilla, equipodId: string | null) {
    return (
      +exp.getPlanillaPartidoJugador()?.getEqid()! === +equipodId! ||
      +exp.getPlanillaPartidoOficialAuxiliar()?.getEqid()! === +equipodId! ||
      +exp.getPlanillaPartidoOficial()?.getEqid()! === +equipodId!
    );
  }

  getCantidadAmarillas(equipodId: string | null) {
    const planillaEventos = this.getPlanillaEventoInput().getValue() as EventoXPlanilla[];
    const amarillas = planillaEventos.filter((exp) => {
      return (
        exp.getActivo() &&
        +exp.getPlanillaPartidoJugador()?.getEqid()! === +equipodId! &&
        exp.getTipoEventoPlanilla()?.isTarjetaAmarilla()
      );
    }).length;
    return amarillas;
  }

  getCantidadAmarillasEnTodoElEquipo(equipoId: string | null) {
    const planillaEventos = this.getPlanillaEventoInput().getValue() as EventoXPlanilla[];
    const amarillas = planillaEventos.filter((exp) => {
      return (
        exp.getActivo() && this.esDelEquipo(exp, equipoId) && exp.getTipoEventoPlanilla()?.isTarjetaAmarilla()
      );
    }).length;
    return amarillas;
  }

  getCantidadDosMinutosEnTodoElEquipo(equipoId: string | null) {
    const planillaEventos = this.getPlanillaEventoInput().getValue() as EventoXPlanilla[];
    const amarillas = planillaEventos.filter((exp) => {
      return (
        exp.getActivo() && this.esDelEquipo(exp, equipoId) && exp.getTipoEventoPlanilla()?.isTarjetaAmarilla()
      );
    }).length;
    return amarillas;
  }

  getCantidadRojasEnTodoElEquipo(equipoId: string | null) {
    const planillaEventos = this.getPlanillaEventoInput().getValue() as EventoXPlanilla[];
    const rojas = planillaEventos.filter((exp) => {
      return (
        exp.getActivo() && this.esDelEquipo(exp, equipoId) && exp.getTipoEventoPlanilla()?.isTarjetaroja()
      );
    }).length;
    return rojas;
  }

  getCantidadAzulsEnTodoElEquipo(equipoId: string | null) {
    const planillaEventos = this.getPlanillaEventoInput().getValue() as EventoXPlanilla[];
    const azuls = planillaEventos.filter((exp) => {
      return (
        exp.getActivo() && this.esDelEquipo(exp, equipoId) && exp.getTipoEventoPlanilla()?.isTarjetaAzul()
      );
    }).length;
    return azuls;
  }

  getCantidadAmarillasOficiales(equipodId: string | null) {
    const planillaEventos = this.getPlanillaEventoInput().getValue() as EventoXPlanilla[];
    const amarillas = planillaEventos.filter((exp) => {
      return (
        exp.getActivo() &&
        (+exp.getPlanillaPartidoOficialAuxiliar()?.getEqid()! === +equipodId! ||
          +exp.getPlanillaPartidoOficial()?.getEqid()! === +equipodId!) &&
        exp.getTipoEventoPlanilla()?.isTarjetaAmarilla()
      );
    }).length;
    return amarillas;
  }

  getCantidadDosMinutosOficiales(equipodId: string | null) {
    const planillaEventos = this.getPlanillaEventoInput().getValue() as EventoXPlanilla[];
    const amarillas = planillaEventos.filter((exp) => {
      return (
        exp.getActivo() &&
        (+exp.getPlanillaPartidoOficialAuxiliar()?.getEqid()! === +equipodId! ||
          +exp.getPlanillaPartidoOficial()?.getEqid()! === +equipodId!) &&
        exp.getTipoEventoPlanilla()?.isDosMinutos()
      );
    }).length;
    return amarillas;
  }

  getCantidadGolesLocal() {
    const equipoLocalId = this.getEquipoLocal().getId();
    return this.getCantidadGoles(equipoLocalId);
  }

  getCantidadGolesVisitante() {
    const equipoVisitanteId = this.getEquipoVisitante().getId();
    return this.getCantidadGoles(equipoVisitanteId);
  }

  getEventosForList() {
    const planillaEventos = this.getPlanillaEventoInput().getValue() as EventoXPlanilla[];
    return planillaEventos
      .filter((exp) => exp.getActivo())
      .sort((exp1, exp2) => (exp1.getMinutoEnSegundos() > exp2.getMinutoEnSegundos() ? -1 : 1))
      .map((exp) => this.mapEventoForList(exp));
  }

  getExclusionesForList(equipodId: string, tiempoActual: string) {
    const planillaEventos = this.getPlanillaEventoInput().getValue() as EventoXPlanilla[];
    const exclusiones = planillaEventos
      .filter(
        (exp) =>
          exp.getActivo() &&
          exp.getTiempoRestante(tiempoActual) > 0 &&
          (exp.getTipoEventoPlanilla()?.getNombre() === DOS_MINUTOS ||
            exp.getTipoEventoPlanilla()?.getNombre() === TARJETA_ROJA) &&
          (+exp.getPlanillaPartidoJugador()?.getEqid()! === +equipodId! ||
            +exp.getPlanillaPartidoOficial()?.getEqid()! === +equipodId! ||
            +exp.getPlanillaPartidoOficialAuxiliar()?.getEqid()! === +equipodId!)
      )
      .sort((exp1, exp2) => (+exp1.getMinuto() < +exp2.getMinuto() ? -1 : 1))
      .reduce<ExclusionData[]>((exclusionesArray, exp) => {
        const exclusionInfo = this.mapExclusionInfo(exp);
        const _exclusion = exclusionesArray.find(
          (_e) => _e.id === exclusionInfo.id && _e.rol === exclusionInfo.rol
        );
        if (_exclusion) {
          _exclusion.restanteSeconds += DURACION_SANCION_EN_MINUTOS * 60;
          _exclusion.restante = this.getTiempoRestante(_exclusion.restanteSeconds);
        } else {
          exclusionesArray.push(this.mapExclusionForList(exp, tiempoActual));
        }
        return exclusionesArray;
      }, []);
    return exclusiones;
  }

  getPreviousMessageForError(rol: string, id: number, error: ErrorEvent) {
    let eqId: any = '';
    let msg = '';

    const planillaPartido = this.getPlanillaPartidoInput().getValue() as PlanillaPartido;
    if (rol === ROL_JUGADOR) {
      const ppj = planillaPartido.getPlanillaPartidoJugadorList().find((ppj) => +ppj.getId()! === +id);
      eqId = ppj?.getEqid();
      msg = `El jugador ${ppj?.getDorsal()} de `;
    }

    if (rol === ROL_OFICIAL) {
      const ppo = planillaPartido.getPlanillaPartidoOficialList().find((ppo) => +ppo.getId()! === +id);
      eqId = ppo?.getEqid();
      msg = `El oficial A de `;
    }

    if (rol === ROL_OFICIAL_AUXILIAR) {
      const ppoa = planillaPartido
        .getPlanillaPartidoOficialAuxiliarList()
        .find((ppoa) => +ppoa.getId()! === +id);
      eqId = ppoa?.getEqid();
      msg = `El auxiliar ${ppoa?.getOrden()} de `;
    }

    if (+eqId === +this.getEquipoLocal().getId()!) {
      msg += `${this.getEquipoLocal().getClub()?.getNombre()} `;
    }

    if (+eqId === +this.getEquipoVisitante().getId()!) {
      msg += `${this.getEquipoVisitante().getClub()?.getNombre()} `;
    }

    if (error.isForTeam()) {
      if (+eqId === +this.getEquipoLocal().getId()!) {
        msg = `El equipo ${this.getEquipoLocal().getClub()?.getNombre()} `;
      }

      if (+eqId === +this.getEquipoVisitante().getId()!) {
        msg = `El equipo ${this.getEquipoVisitante().getClub()?.getNombre()} `;
      }
    }

    return msg;
  }

  getExclusionesLocalesForList(tiempoActual: string) {
    const equipoLocalId = this.getEquipoLocal().getId();
    return this.getExclusionesForList(equipoLocalId!, tiempoActual);
  }

  getExclusionesVisitantesForList(tiempoActual: string) {
    const equipoVisitanteId = this.getEquipoVisitante().getId();
    return this.getExclusionesForList(equipoVisitanteId!, tiempoActual);
  }

  getPeriodDescription(n: number, isExtra: boolean) {
    switch (n) {
      case 1:
        return `PT${isExtra ? 'E' : ''}`;
      case 2:
        return `ST${isExtra ? 'E' : ''}`;
      case 3:
        return `TT${isExtra ? 'E' : ''}`;
      case 4:
        return `CT${isExtra ? 'E' : ''}`;
      case 5:
        return `QT${isExtra ? 'E' : ''}`;
    }
    return '-';
  }

  getPeriodLongDescription(n: number, isExtra: boolean) {
    switch (n) {
      case 1:
        return `Primer Tiempo ${isExtra ? 'Extra' : ''}`;
      case 2:
        return `Segundo Tiempo ${isExtra ? 'Extra' : ''}`;
      case 3:
        return `Tercer Tiempo ${isExtra ? 'Extra' : ''}`;
      case 4:
        return `Cuarto Tiempo ${isExtra ? 'Extra' : ''}`;
      case 5:
        return `Quinto Tiempo ${isExtra ? 'Extra' : ''}`;
    }
    return '-';
  }

  getEquipoById(eqId: number) {
    const equipoLocalId = this.getEquipoLocal().getId();
    const equipoVisitanteId = this.getEquipoVisitante().getId();
    if (eqId === +equipoLocalId!) {
      return this.getEquipoLocal();
    } else if (eqId === +equipoVisitanteId!) {
      return this.getEquipoVisitante();
    }
  }

  isJugadorExcluido(ppjId: number, tiempoActual: string) {
    const planillaEventos = this.getPlanillaEventoInput().getValue() as EventoXPlanilla[];
    const exclusiones = planillaEventos.filter(
      (exp) =>
        exp.getActivo() &&
        exp.getPpjid() &&
        exp.getTipoEventoPlanilla() &&
        +exp.getPpjid()! === +ppjId &&
        exp.getTipoEventoPlanilla()!.getNombre() === DOS_MINUTOS
    );
    return exclusiones.some((exp) => exp.getTiempoRestante(tiempoActual) > 0);
  }

  createScreenshot(tiempoActual: string, tiempoDetenido: boolean) {
    const planillaPartido = this.getPlanillaPartidoInput().getValue() as PlanillaPartido;
    const equipoLocalId = this.getEquipoLocal().getId();
    const equipoVisitanteId = this.getEquipoVisitante().getId();

    return PlanillaPartidoEnVivo.createFrom(
      'new',
      +planillaPartido.getId()!,
      tiempoActual,
      this.getCantidadGolesLocal(),
      this.getCantidadGolesVisitante(),
      this.getCantidadAmarillasEnTodoElEquipo(equipoLocalId),
      this.getCantidadAmarillasEnTodoElEquipo(equipoVisitanteId),
      this.getCantidadDosMinutosEnTodoElEquipo(equipoLocalId),
      this.getCantidadDosMinutosEnTodoElEquipo(equipoVisitanteId),
      this.getCantidadRojasEnTodoElEquipo(equipoLocalId),
      this.getCantidadRojasEnTodoElEquipo(equipoVisitanteId),
      this.getCantidadAzulsEnTodoElEquipo(equipoLocalId),
      this.getCantidadAzulsEnTodoElEquipo(equipoVisitanteId),
      tiempoDetenido
    );
  }

  // ---------------------------------- METODOS GOLES --------------------------------------

  // getGolesByEquipoId(eqId: number) {
  //   const eventos: EventoXPlanilla[] = this.getPlanillaEventoInput().getValue()
  //   eventos.filter((ev) => ev.)
  // }

  // ---------------------------------- VALIDACION EVENTOS --------------------------------------
  validateEvent(
    tipoEvento: TipoEventoPlanilla,
    id: number,
    rol: string,
    tiempoActual: string,
    refereeReview = false
  ) {
    const eventMngr = PlanillaDigitalFormEventMngr.build(this, refereeReview);
    switch (tipoEvento.getNombre()) {
      case GOL:
        return eventMngr.validateGol(
          id,
          rol,
          tiempoActual,
          this.getPlanillaPartidoInput().getValue().getDiferido()
        );
      case DOS_MINUTOS:
        return eventMngr.validateDosMinutos(id, rol, this.getPlanillaPartidoInput().getValue().getDiferido());
      case TARJETA_AMARILLA:
        return eventMngr.validateAmarilla(id, rol, this.getPlanillaPartidoInput().getValue().getDiferido());
      case TARJETA_ROJA:
        return eventMngr.validateRoja(id, rol, this.getPlanillaPartidoInput().getValue().getDiferido());
      case TARJETA_AZUL:
        return eventMngr.validateAzul(id, rol);
    }
  }

  validateTimeout(eqId: number, periodo: IPeriodos) {
    let timeoutsEnTiempoActual = this.getCantidadTimeoutXEquipo(eqId, periodo.tiempo);

    let timeoutReglamentariosTotales = 0;
    for (let i = 1; i <= periodo.tiempo; i++) {
      if (i <= 2) {
        timeoutReglamentariosTotales += this.getCantidadTimeoutXEquipo(eqId, i);
      }
    }

    let timeoutExtraTotales = 0;
    for (let i = 3; i <= periodo.tiempo; i++) {
      timeoutExtraTotales += this.getCantidadTimeoutXEquipo(eqId, i);
    }

    if (periodo.required && timeoutReglamentariosTotales >= CANT_MAX_TIMEOUTS_EN_TIEMPO_REGLAMENTARIO) {
      throw new ErrorEvent('El equipo ya alcanzó el límite de timeouts totales.');
    }

    if (periodo.required && timeoutsEnTiempoActual >= CANT_MAX_TIMEOUTS_POR_TIEMPO) {
      throw new ErrorEvent('El equipo ya alcanzó el límite de timeouts por tiempo.');
    }

    // if (!periodo.required && periodo.isExtra && timeoutExtraTotales >= CANT_MAX_TIMEOUTS_EN_TIEMPOS_EXTRA) {
    if (!periodo.required && periodo.isExtra) {
      throw new ErrorEvent('No se pueden pedir timeouts en tiempo extra.');
    }

    return true;
  }

  toPlanillaPartido(): PlanillaPartido {
    const planillaPartido = this.getPlanillaPartidoInput().getValue() as PlanillaPartido;
    const golesLocal = this.getCantidadGolesLocal();
    const golesVisitante = this.getCantidadGolesVisitante();
    const informe = this.getInformeInput().getValue();
    const observaciones = this.getObservacionesInput().getValue();
    planillaPartido.prepareForSaveFromPlanillaOnline(golesLocal, golesVisitante, informe, observaciones);
    return planillaPartido;
  }
}

export default PlanillaDigitalForm;
